import { CartPromotionsEngineProduct } from './cart-promotions-engine';

interface PromotionEngineProductSource {
  id: string;
  name: string;
}

/**
 * Maps catalog product entities into the slim shape the cart promotions engine
 * needs. The engine reasons about presentations via the cart items (groupKey),
 * so the per-presentation basePrice is derived there — no presentation data
 * is required from the product side.
 */
export function toCartPromotionsEngineProducts(
  products: PromotionEngineProductSource[],
): CartPromotionsEngineProduct[] {
  return products.map(product => ({ id: product.id, name: product.name }));
}
